import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  minutes?: number;
}
export function CountdownTimer({
  minutes = 15
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(minutes * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => setTimeLeft(prev => prev - 1), 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center gap-2 md:gap-4 justify-center md:justify-start" data-id="element-65">
      <div className="flex flex-col items-center" data-id="element-66">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-67">
          {format(h)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-68">
          Horas
        </span>
      </div>
      <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold pb-5" data-id="element-69">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-70">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-71">
          {format(m)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-72">
          Min
        </span>
      </div>
      <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold pb-5" data-id="element-73">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-74">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-75">
          {format(s)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-76">
          Seg
        </span>
      </div>
    </div>;
}